import { allRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/communication-activity";

/**
 * The communication activities list - every email sent. The search endpoint only
 * searches one day at a time, so Created On is a day rather than a range, and it
 * returns at most 100 activities in one page, ignoring the page asked for.
 */
export const communicationActivitiesListDefinition: ListDefinition = {
  path: "/communication-activities",
  entityName: "g4c_communicationactivity",
  recordRoute,
  title: "Communication Activities",
  allowedRoles: allRoles,
  data: "search-paged",
  searchOnLoad: true,
  // In the legacy page's order.
  filters: [
    {
      // Matched by id, which needs the Ticketing search that accepts it.
      name: "g4c_communication",
      label: "Communication",
      kind: "lookup",
      lookupEntity: "g4c_communication",
      searchable: true,
    },
    { name: "g4c_recipientcontactname", label: "Contact", kind: "text" },
    {
      name: "g4c_recipientemailaddress",
      label: "Email Address",
      kind: "text",
      width: "wide",
    },
    // Off leaves test sends out, as the legacy filter's default did.
    {
      name: "g4c_test",
      label: "Include tests",
      kind: "boolean",
    },
    {
      name: "createdon",
      label: "Created On",
      kind: "day",
    },
  ],
  filterDescription:
    "Results are limited to 100 records. Apply more filters to refine your search. When searching by email address, the value must be an exact match.",
  defaultSortKey: "createdon",
  defaultSortDir: "desc",
  // The whole of what the search returns, so no page asks for rows it won't send.
  pageSize: 100,
  columns: [
    {
      // Each activity is one send, so it's named by when it went.
      key: "scheduledstart",
      label: "Send Time",
      width: 200,
      sortable: true,
      display: "datetime",
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      // The search names each row after its communication.
      key: "Name",
      label: "Communication",
      width: 300,
    },
    {
      key: "statecode",
      label: "Activity Status",
      width: 200,
      sortable: true,
      display: "component",
      componentKey: "communicationActivityStatus",
    },
    {
      key: "g4c_recipientcontactname",
      label: "Contact",
      width: 200,
      sortable: true,
      link: { to: "/contact", idKey: "g4c_recipientcontact", newTab: "button" },
    },
    {
      key: "g4c_recipientemailaddress",
      label: "Email Address",
      width: 300,
      sortable: true,
    },
    {
      key: "g4c_test",
      label: "Test",
      width: 200,
      sortable: true,
      display: "yesno",
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      sortable: true,
      display: "datetime",
    },
  ],
};
